import AppTable from "@lib/components/MiniComponents/Table/AppTable";
import { ApiParams } from "@lib/types/Api";
import { useMemo } from "react";
import useIntl from "react-intl/lib/src/components/useIntl";
import { useNavigate } from "react-router-dom";
import getColumns from "./columns";
import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { StyledExpandedCard } from "@lib/components/StyledComponents";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { apiGetCustomerLeadScannedTransaction } from "@lib/api/walletSendByte";
import { useQuery } from "@tanstack/react-query";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import { SendByteWalletAddress } from "@lib/types/SendByte";

type Props = {
  item: SendByteWalletAddress;
};

export default function WalletItemDetail({ item }: Props) {
  const { messages } = useIntl();
  const navigate = useNavigate();

  const params: ApiParams = {
    limit: 3,
    sort: "confirmedDate,DESC",
    filter: [`walletAddressId||$eq||${item.id}`],
    join: ["walletAddress", "customer", "customerUser"],
  };

  const leadBlockchainPaymentsQuery = useQuery({
    queryFn: () => apiGetCustomerLeadScannedTransaction(params),
    queryKey: [
      "customer-lead-blockchain-payments",
      params ? JSON.stringify(params) : item.customerUserId,
    ],
    enabled: !!params && !!item.customerUserId,
  });

  const { data, isLoading, isFetching, refetch } = leadBlockchainPaymentsQuery;
  const apiData = data?.data?.data;

  const columns = useMemo(
    () =>
      getColumns({
        apiData,
        messages,
        navigate,
      }),
    [apiData, params],
  );

  return (
    <StyledExpandedCard>
      <AppTable
        dataSource={apiData}
        columns={columns}
        rowKey={"id"}
        loading={isLoading || isFetching}
      />
      <StyledFlex style={{ justifyContent: "space-between" }}>
        <Typography style={{ marginTop: 10 }}>
          {messages["common.walletAddress"] as string} : <i>{item.address}</i>
          {" - "}
          <FormattedMessage
            id="common.showingLastXItems"
            values={{ x: params.limit }}
          />
        </Typography>

        <ActionButton
          type="refresh"
          noLabel
          noBg
          size="small"
          onClick={() => refetch()}
          disabled={isFetching}
          loading={isFetching}
          query={leadBlockchainPaymentsQuery}
        />
      </StyledFlex>
    </StyledExpandedCard>
  );
}
